import { Action, SubjectRoles } from "@/api-schema-enums";
import { AppAbility } from "@/casl-provider";
import { User } from "@/store/user-store";
import { AbilityBuilder } from "@casl/ability";

export function setRulePermissions(user: User, builder: AbilityBuilder<AppAbility>) {
  const { can } = builder;

  if (user.roles.includes(SubjectRoles.RamAdministrator)) {
    can(Action.Manage, "Rule");
  }
}
